module.exports = __webpack_public_path__ + "static/media/loading5.b41fbe7d.gif";